import { useEffect } from 'react';
import { formatUserSearchDetails, writeUserSearchDetails } from '@pkgs/components/utils/userSearchDetails';
import { mapSearchStateToSearchListingsFilters } from '@pkgs/components/utils/mapFilterFields';

import { useAppContext } from './useAppContext';
import { useSearchStoreContext } from './stores/search/useSearchStore';
import { usePromptStore } from './stores/search/usePromptStore';

export const usePersistUserSearchDetails = (): void => {
  const { options, t } = useAppContext();
  const searchStore = useSearchStoreContext();

  const promptValue = usePromptStore((state) => state.promptValue);

  useEffect(() => {
    const persistSearchDetails = () => {
      const state = searchStore.getState().getStateSnapshot();
      const placeName = state.placeName?.trim() || (state.multiPolygon ? t('search.searchAlert.filterSummary.selectedArea') : '');
      const details = formatUserSearchDetails({
        searchMode: state.searchMode,
        prompt: promptValue,
        filters: mapSearchStateToSearchListingsFilters(state),
        placeName,
        t,
        options,
      });

      writeUserSearchDetails(details);
    };

    persistSearchDetails();
    return searchStore.subscribe(persistSearchDetails);
  }, [options, promptValue, searchStore, t]);
};
